// extracted by mini-css-extract-plugin
export default {"container":"Featured_container__On6jp","featuredHeader":"Featured_featuredHeader__SNGTq","card":"Featured_card__XHfKx","go":"Featured_go__8DozX"};